// Lightweight US / UK / AU phone validation (digit-count based) — mirrors backend phone.py.
export function parsePhone(raw) {
  raw = (raw || '').trim();
  if (!raw) return { valid: false, country: null };
  const digits = raw.replace(/\D/g, '');
  if (!digits) return { valid: false, country: null };

  if (raw.startsWith('+1') || raw.startsWith('001')) {
    const nsn = raw.startsWith('001') ? digits.slice(3) : digits.slice(1);
    return { valid: nsn.length === 10, country: nsn.length === 10 ? 'US' : null };
  }
  if (raw.startsWith('+44') || raw.startsWith('0044')) {
    const nsn = raw.startsWith('0044') ? digits.slice(4) : digits.slice(2);
    const ok = nsn.length >= 9 && nsn.length <= 10;
    return { valid: ok, country: ok ? 'UK' : null };
  }
  if (raw.startsWith('+61') || raw.startsWith('0061')) {
    const nsn = raw.startsWith('0061') ? digits.slice(4) : digits.slice(2);
    return { valid: nsn.length === 9, country: nsn.length === 9 ? 'AU' : null };
  }
  if (raw.startsWith('+') || raw.startsWith('00')) return { valid: false, country: null };

  if (digits.startsWith('1') && digits.length === 11) return { valid: true, country: 'US' };
  if (digits.startsWith('0')) {
    const ok = digits.length === 10 || digits.length === 11;
    return { valid: ok, country: ok ? 'UK/AU' : null };
  }
  if (digits.length === 10) return { valid: true, country: 'US' };
  return { valid: false, country: null };
}

export function isValidPhone(raw) {
  return parsePhone(raw).valid;
}
